import { useMaterial } from "./hooks/useMaterial";
import MaterialView from "./view";

export default function Material() {
    const props = useMaterial();
    return <MaterialView {...props} />;
}
